module fdm.clientManagement {
    export class ClientManagementService {
   
    }

    angular.module('fdm.clientManagement')
        .service('clientManagementService', ClientManagementService);
}